import { render, staticRenderFns } from "./UserProfileInfo.vue?vue&type=template&id=0c828b61&scoped=true"
import script from "./UserProfileInfo.vue?vue&type=script&lang=js"
export * from "./UserProfileInfo.vue?vue&type=script&lang=js"
import style0 from "./UserProfileInfo.vue?vue&type=style&index=0&id=0c828b61&prod&lang=scss"
import style1 from "./UserProfileInfo.vue?vue&type=style&index=1&id=0c828b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c828b61",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QMenu});
